// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"e0b43f73","243":"cf6da472","453":"5333ad58","578":"2b38fa85","763":"084b137f","781":"a7a4019c","837":"481336ac","898":"5ce5ca5e"}[chunkId] + ".chunk.js";
};